// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';

// On importe les styles globaux
import './index.css';

// On importe le composant principal de l'application
import App from './App';

// On cible la div avec l'ID 'root' dans public/index.html
const root = ReactDOM.createRoot(document.getElementById('root'));

// On dit à React de "rendre" (d'afficher) notre application
// à l'intérieur de cette div.
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);